import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FileManagerContainer from './FileManager/FileManagerContainer'
import Modal from 'react-responsive-modal'

export default class FileInputField extends Component {
  static propTypes = {
    input: PropTypes.object,
    documentTypeId: PropTypes.any,
    editMode: PropTypes.bool
  }

  static defaultProps = {
    editMode: false
  }

  constructor (props) {
    super(props)
    this.state = {
      showFileManagerModal: false
    }

    this.onOpenFileManagerModal = this.onOpenFileManagerModal.bind(this)
    this.onCloseFileManagerModal = this.onCloseFileManagerModal.bind(this)
    this.onDocumentSelected = this.onDocumentSelected.bind(this)
  }

  onOpenFileManagerModal () {
    const { editMode, input } = this.props
    const { value } = input
    if (editMode && value.approved) {
      return
    }

    this.setState({
      showFileManagerModal: true
    })
  }

  onCloseFileManagerModal () {
    this.setState({
      showFileManagerModal: false
    })
  }

  onDocumentSelected (document) {
    const { input } = this.props
    const { onChange } = input
    onChange(document)
    this.setState({
      showFileManagerModal: false
    })
  }

  render () {
    const { showFileManagerModal } = this.state
    const { input, documentTypeId, editMode } = this.props
    const { value } = input
    return (
      <div style={{textAlign: 'left'}}>
        {editMode && value.approved ? (
          <span className="text-success" style={{fontWeight: 'bold'}}>
            Approvato
          </span>
        ) : (
          <a
            className="btn-file-browser-confirm"
            style={{height: '34px'}}
            onClick={this.onOpenFileManagerModal}>
            {value ? 'Cambia' : 'Seleziona documento'}
          </a>
        )}
        <span style={{paddingLeft: '5px', fontWeight: 'bold', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
          {value && value.name}
        </span>
        <Modal
          classNames={{modal: 'container'}}
          open={showFileManagerModal}
          onClose={this.onCloseFileManagerModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
        >
          <h3>Gestione Documenti</h3>
          <FileManagerContainer
            documentTypeId={documentTypeId}
            onFileSelected={this.onDocumentSelected}
          />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FileInputField.js